import { type LocationListingQuery } from 'cms/cms';
import { type LocationCardProps } from '4-sections/FilteredListings/MapAndListing/LocationCard';
import { resolveLocationPagesToLocationCards } from './locationCardResolver';

export type LocationPage = NonNullable<LocationListingQuery['LocationPage']>;
export type LocationPageItems = NonNullable<LocationPage['items']>;

export interface RegionName {
    name: string;
    description: string;
}

export interface LocationCardGroup {
    title: string;
    cardItems: LocationCardProps[];
}

export type LocationCardGroups = LocationCardGroup[];

export const resolveLocationPagesToLocationCardGroups = (items: LocationPageItems, regionNames: RegionName[]): LocationCardGroup[] => {
    const cardGroups = regionNames.map(({ name, description }) => {
        const filteredItems = items.filter(item => {
            const { RegionCategories } = item as NonNullable<typeof item>;
            return RegionCategories?.find(RegionCategory => {
                const { Name } = RegionCategory as NonNullable<typeof RegionCategory>;
                return Name === name;
            }) || false;
        });

        return {
            title: description || name,
            cardItems: resolveLocationPagesToLocationCards(filteredItems),
        };
    });

    return cardGroups.filter(({ cardItems }) => {
        return !!cardItems.length;
    });
};
